import api from '../api';

export const getTalentPools = () => {
  return api.get('/contractor/v2/talent-pools', {
    // Explicitly set the role here
    role: 'contractor'
  });
};

export const getTalentPool = (talentPoolId) => {
  return api.get(`/contractor/v2/talent-pools/${talentPoolId}`, {
    role: 'contractor'
  })
}

export const applyToTalentPool = (talentPoolId) => {
  return api.post(`/contractor/v2/talent-pools/${talentPoolId}/apply`, null, {
    role: 'contractor'
  });
};

export const withdrawApplication = (talentPoolId) => {
  return api.delete(`/contractor/v2/talent-pools/${talentPoolId}/apply`, {
    role: 'contractor'
  });
};

